import { defineStore } from "pinia"
import http from "../services/http"
import storage from "~/services/storage"

interface ISmartTopicState {
  subjects: any[]
  grades: any[]
  sections: any[]
  subjectGradeFilter: any
}

interface IFetchSubjectsArguments {
  successCallback?: (context: any) => void
  errorCallback?: (context: any) => void
}

interface IFetchSectionArguments extends IFetchSubjectsArguments {
  subjectSlug: string
  gradeSlug: string
}

export const useSmartTopicStore = defineStore("smartTopicStore", {
  state: (): ISmartTopicState => ({
    subjects: [],
    grades: [],
    sections: [],
    subjectGradeFilter: [],
    // currentSubject: null,
    // userGradeSlug: [],
    // topics: [],
    // responses_reviews: [],
    // queue: [],
    // data: {
    //   filter: {},
    // },
  }),

  getters: {
    noSubjects(state) {
      return state.subjects.length < 1
    },
  },

  actions: {
    fetchSubjects({ successCallback = null, errorCallback = null }: IFetchSubjectsArguments) {
      this.sections = []

      http.get({
        url: "/v2/smart-topics/subjects",
        successCallback: (context) => {
          this.subjects = context.response._data.subjects
          if (successCallback) {
            successCallback(context.response)
          }
        },
        errorCallback,
      })
    },

    fetchSections({ subjectSlug, gradeSlug, successCallback, errorCallback }: IFetchSectionArguments) {
      http.get({
        url: "/v1/smart-topics/sections-by-grade",
        params: { subjectSlug },
        successCallback: (context) => {
          this.grades = context.response._data.grades

          this.subjects.forEach((subject) => {
            this.subjectGradeFilter[subject.slug] = this.getSubjectGradeFilter(subjectSlug) || []
          })

          if (gradeSlug) {
            this.sections = this.getGrade(gradeSlug).sections
          } else {
            this.sections = []
          }

          if (successCallback) {
            successCallback(context.response)
          }
        },
        errorCallback,
      })
    },

    setSections(gradeSlug: string) {
      this.sections = this.getGrade(gradeSlug)?.sections || []
    },

    getSubject(subjectSlug: string) {
      return this.subjects.find((subject) => subject.slug === subjectSlug)
    },

    getGrade(gradeSlug: string) {
      return Object.values(this.grades).find((grade) => grade.slug === gradeSlug)
    },

    getSection(sectionSlug: string) {
      return this.sections.find((section) => section.slug === sectionSlug)
    },

    setSubjectGradeFilter(subjectSlug: string, value?: string[]) {
      this.subjectGradeFilter[subjectSlug] = value || []
      storage.setSmartTopicsSubjectGradeFilter(subjectSlug, this.subjectGradeFilter[subjectSlug])
    },

    getSubjectGradeFilter(subjectSlug: string) {
      this.subjectGradeFilter[subjectSlug] = storage.getSmartTopicsSubjectGradeFilter(subjectSlug) || []
    },

    getSubjectById(id: number) {
      return this.subjects.find((subject) => subject.id === id)
    },
  },
})

export default {
  // isBusy(name) {
  //   return this.state.queue.includes(name)
  // },
  // setBusy(name) {
  //   this.state.queue.push(name)
  //   if (!this.state.busy) { this.state.busy = true }
  // },
  // removeBusy(name) {
  //   if (!this.isBusy(name)) return
  //   this.state.queue.splice(this.state.queue.indexOf(name), 1)
  //   if (this.state.busy && this.state.queue.length === 0) {
  //     this.state.busy = false
  //   }
  // },
  // findCurrentSubject(slug, successCallback) {
  //   this.state.sections = []
  //   this.state.currentSubject = _.find(this.state.subjects, {slug: slug})
  //   if (!this.state.currentSubject) {
  //     this.loadSubjects((response) => {
  //       this.state.currentSubject = _.find(this.state.subjects, {slug: slug})
  //       successCallback && successCallback(response)
  //     })
  //   } else if (successCallback) {
  //     successCallback()
  //   }
  // },
  // loadTopics(subject_slug, grade_slug, section_slug, successCallback, errorCallback) {
  //   this.state.topics = []
  //   http.get('smart-topics/topics', {subject_slug, grade_slug, section_slug}, (response) => {
  //     this.state.topics = response.data.topics
  //     if (successCallback) {
  //       successCallback(response)
  //     }
  //   }, errorCallback)
  // },
}
